export default "__VITE_ASSET__90c5141a__"